export default __webpack_public_path__ + "static/isha-patel-5989b9cda581e7caa9ef3662972ed183.jpg";